export enum EmailAccountConnectorPrivacyLevelEnum {
    SHARED = 'SHARED',
    PRIVATE = 'PRIVATE',
}
